module.exports = __webpack_public_path__ + "static/media/mini-utilities.959ab6ec.svg";